/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Button, Grid, Link, SvgIcon } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { useDispatch, useSelector } from 'react-redux';
import { loginRequest } from '../../auth/authConfig';
import { setCurrentUserState, setFromSignup } from '../../actions/actions';
import appSettings from '../../appSettings';
import { createEnrollment, createNewUser, updateContact } from '../../common/services/Services';
import { fetchDomain } from '../../common/services/proxyServices';
import { handleFormInputChange, handleFormValidation } from '../../common/utilities/CustomValidatorUtil';
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import { handleValidateAgent, validationCheck, verifyLicensedData } from '../../common/utilities/HandleVerifyUserUtil';
import { ErrorComponent, ImageComponent, LoadingComponent } from '../../components';
import CommonBannerComponent from '../../components/common/CommonBannerComponent/CommonBannerComponent';
import CustomToolTip from '../../components/common/CustomToolTip';
import overrides from '../../common/theme/OverrideStyles';
import constants from '../../constants';
import '../../common/theme/UserFlowPage.scss';

const defaultTheme = createTheme();
const theme = createTheme(overrides);

const AddUserPage = ({refreshToken, ciamAccountExists, accountInfo, contactInfo, ciamName, openGlobalBanner}) => {
    const dispatch = useDispatch();
    const ssoAgent = useSelector(state => state.agencyId);
    const mailBoxImage = require('../../img/mail-box-image.png');
    const authRequest = { ...loginRequest };
    const initialFormValues = {
        username: '',
        npn: ciamAccountExists ? '' : contactInfo.nationalProducerNumber,
        dateofbirth: ciamAccountExists ? '' : contactInfo.dateofbirth
    };
    const initialErrors = {
        username: '',
        npn: '',
        ...(ciamAccountExists && { dateOfBirth: '' })
    };
    const accountLicensed = contactInfo.nationalProducerNumber ? true : false;
    const initialIsLicensedValue = false;
    const allowNpn = contactInfo.nationalProducerNumber ? true : false;
    const { history, formValues, setFormValues, errors, setErrors, isLicensed, setIsLicensed, licensedData, setLicensedData, showBannerType, setShowBannerType, isEditable, setIsEditable, isValid, setIsValid, isLoading, setIsLoading, loaderStyle } = HandleFormUtil(initialFormValues, initialErrors, initialIsLicensedValue, allowNpn);

    useEffect(() => {
        if(licensedData !== undefined && licensedData.canEnroll) {
            onValidateAgent(false);     
        }
    }, [licensedData]);  

    const onInputChange = (event) => {
        handleFormInputChange(event, setFormValues);
    };

    const onValidation = (event) => {
        handleFormValidation(event, setErrors, validationCheck);
    };

    const getDomain = async (licensedValues) => {
        let domain = '';
        if (licensedData && Object.keys(licensedData).length > 0) {
            const updatedLicensedValues = {...licensedValues, ...licensedData.data.userData};
            domain = updatedLicensedValues !== undefined && updatedLicensedValues.mGroupName ? await fetchDomain(updatedLicensedValues.mGroupName) : null;
            return { domain, licensedValues: updatedLicensedValues };
        }
        return { domain, licensedValues };
    };

    const createUserAccount = async (enrollmentData, licensedValues, domain, token) => {
        if(!ciamAccountExists) { 
            return; 
        }
        enrollmentData = { ciamId: accountInfo.oid, email: accountInfo.email, mobilePhone: contactInfo.mobilePhone, prismId: licensedValues.userId, lpId: licensedValues.lpId, firstName: licensedValues.firstName, lastName: licensedValues.lastName, dob: licensedValues.dob, npn: licensedValues.npn, domain: domain, prid: licensedValues.prid, mGroupName: licensedValues.mGroupName };
        const respCreateNewUser = await createNewUser(enrollmentData, token);
        if (respCreateNewUser.enrolled) {
            dispatch(setCurrentUserState(licensedValues.userId));
            window.location.replace(`${appSettings.AZURE_AD_CLIENT_REDIRECT_URI}?add=true`);
            return;
        }
        setIsLoading(false);
        return;
    }

    const createUserEnrollment = async (enrollmentData, token, npn, userId) => {
        try {
            const respCreateEnrollment = await createEnrollment(enrollmentData, token);
            if(!accountInfo.npn && npn) {
                let userData = {
                    ciamId: accountInfo.oid,
                    updatednpn: npn
                };
                await updateContact(userData, token);
            }
            if(respCreateEnrollment.status === 'Success') {
                dispatch(setCurrentUserState(userId));
                window.location.replace(`${appSettings.AZURE_AD_CLIENT_REDIRECT_URI}?add=true`);
                return;
            }
            setIsLoading(false);
            return;
        } catch (error) {
            openGlobalBanner(error);
            setIsLoading(false);
        }
    }

    const onValidateAgent = async (runValidate) => {
        setIsLoading(true);
        const { token } = await refreshToken();
        let licensedValues = {};
        if(Object.keys(contactInfo).length === 0 && ciamAccountExists) {
            dispatch(setFromSignup(false));
        }
        const contactFormValues = {
            ...formValues,
            lastName: ciamName.lastName
        };
        const { domain, licensedValues: updatedLicensedValues } = await getDomain(licensedValues);
        licensedValues = updatedLicensedValues;
        if(verifyLicensedData(licensedData, contactFormValues, setShowBannerType, 'add', ssoAgent, accountLicensed, domain)) {
            if(licensedData?.canEnroll) {
                let enrollmentData = {};
                await createUserAccount(enrollmentData, licensedValues, domain, token);
                enrollmentData = { contactId: contactInfo.contactId, ciamId: accountInfo.oid, prismId: licensedValues.userId, lpId: licensedValues.lpId, domain: domain, prid: licensedValues.prid, mGroupName: licensedValues.mGroupName };
                await createUserEnrollment(enrollmentData, token, licensedValues.npn, licensedValues.userId);
            }
        } else {
            setIsLoading(false);
        }
        if(runValidate) {
            handleValidateAgent(formValues, history, setIsLoading, setShowBannerType, setIsLicensed, setLicensedData, setIsEditable, setIsValid, isLicensed);
        }
    };
  
    const handlePrevStep = () => {
        delete formValues.npn;
        delete errors.npn;
        formValues.username = '';
        setShowBannerType(undefined);
        setIsEditable(true);
        setIsLicensed(false);
    }
    
    if (isLoading) {
        return <LoadingComponent />;
    }

    return (
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={authRequest}
                errorComponent={ErrorComponent}
                loadingComponent={LoadingComponent}>
                <Box className='userFlow agent-ciam-container'>
                    <Box className='userFlow-container'>
                        <Grid container justify='space-between' className='container-styling'>
                            <Grid size={{ xs: 12, lg: 5 }}>
                                <ImageComponent src={mailBoxImage} />
                            </Grid>
                            <Grid size={{ xs: 12, lg: 7 }}>
                                <Box>
                                    <Box className='userFlowText licensed-agent'>
                                        <Box className='eyebrow'>
                                                {ciamAccountExists ? constants.updateUsername : constants.addUsername}
                                        </Box>
                                        <Box className='title'>
                                            Enter a username to add it to your AMsuite+ account                                </Box>
                                        <CommonBannerComponent bannerState='inline' bannerType={showBannerType === 'E100' ? 'E100A' : showBannerType} />
                                        <p className='addUserFlow-content'>
                                        </p>
                                        <ThemeProvider theme={defaultTheme}>
                                            <form className='addUser-form'>
                                                <Box className={(isLicensed && !ciamAccountExists) ? 'user-npn' : 'user'}>
                                                    <Box className={(isLicensed  && !ciamAccountExists) ? 'user-field' : ''} >
                                                        <Box className='userFlow-field'>
                                                            <Box className='userFlow-tooltip'>
                                                                <label htmlFor='username' >
                                                                    Username
                                                                </label>
                                                                <ThemeProvider theme={theme}>
                                                                <CustomToolTip message={<Box className='tooltip-content'>If you are a new user, 'username' can be found in your Welcome email. If you are a returning user, please enter your modernLINK username.</Box>}></CustomToolTip>
                                                                </ThemeProvider>
                                                            </Box>
                                                            <input
                                                                id='username'
                                                                className='inputfield'
                                                                placeholder='Enter your username'
                                                                onChange={onInputChange}
                                                                onBlur={onValidation}
                                                                disabled={!isEditable}
                                                                value={formValues.username}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    {(isLicensed && !ciamAccountExists)&& (
                                                        <Box className='npn-field addUser-npn-field'>
                                                            <Box className='npn-tooltip'>
                                                                <label
                                                                htmlFor='npn'
                                                                className='npn-label'
                                                                >
                                                                National Producer Number (NPN)
                                                                </label>
                                                                <ThemeProvider theme={theme}>
                                                                <CustomToolTip message={<Box className='tooltip-content'><Box>You can search for your National Producer Number here</Box><Box><a href="https://nipr.com/licensing-center/look-up-a-national-producer-number" target="_blank" rel='noreferrer'>https://nipr.com/licensing-center/look-up-a-national-producer-number</a></Box></Box>}></CustomToolTip>
                                                                </ThemeProvider>
                                                            </Box>
                                                            <input
                                                                id='npn'
                                                                className={`${errors.npn ? 'errorfocus' : ''} ${!initialIsLicensedValue ? 'highlight' : ''}`}
                                                                placeholder='Enter your NPN'
                                                                variant='outlined'
                                                                onChange={onInputChange}
                                                                onBlur={onValidation}
                                                            />
                                                            {errors.npn && (
                                                                <span className='errormsg'>{errors.npn}</span>
                                                            )}
                                                        </Box>
                                                    )}
                                                    {ciamAccountExists && (
                                                        <Box className={(isLicensed) ? 'dob-npn' : 'dob'}>
                                                            <Box className={(isLicensed) ? 'dob-field' : ''} >
                                                                <label
                                                                htmlFor='dateofbirth'
                                                                >
                                                                Date of birth
                                                                </label>
                                                                <input
                                                                id='dateofbirth'
                                                                type='date'
                                                                onChange={onInputChange}
                                                                onBlur={onValidation}
                                                                name='dob'
                                                                value={formValues.dateofbirth}
                                                                disabled={!isEditable}
                                                                className={`${
                                                                    formValues.dateofbirth ? 'dob--has-value' :
                                                                    errors.dateofbirth ? 'errorfocus' :
                                                                    ''}`}
                                                                />
                                                                {errors.dateofbirth && (
                                                                <span className='errormsg'>{errors.dateofbirth}</span>
                                                                )}
                                                            </Box>
                                                            {(isLicensed) && (
                                                                <Box className='npn-field'>
                                                                <Box className='npn-tooltip'>
                                                                    <label
                                                                    htmlFor='npn'
                                                                    className='npn-label'
                                                                    >
                                                                    National Producer Number (NPN)
                                                                    </label>
                                                                    <ThemeProvider theme={theme}>
                                                                    <CustomToolTip message={<Box className='tooltip-content'><Box>You can search for your National Producer Number here</Box><Box><a href="https://nipr.com/licensing-center/look-up-a-national-producer-number" target="_blank" rel='noreferrer'>https://nipr.com/licensing-center/look-up-a-national-producer-number</a></Box></Box>}></CustomToolTip>
                                                                    </ThemeProvider>
                                                                </Box>
                                                                <input
                                                                    id='npn'
                                                                    className={`${errors.npn ? 'errorfocus' : ''
                                                                    }`}
                                                                    placeholder='Enter your NPN'
                                                                    variant='outlined'
                                                                    onChange={onInputChange}
                                                                    onBlur={onValidation}
                                                                />
                                                                {errors.npn && (
                                                                    <span className='errormsg'>{errors.npn}</span>
                                                                )}
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    )}
                                                </Box>
                                            </form>
                                        </ThemeProvider>
                                    </Box>
                                    <Box className='buttonsBox'>
                                        <Box className='continueButton'>
                                            <Button
                                                disableRipple
                                                disabled={!isValid}
                                                className='button-styling continue-button'
                                                style={loaderStyle}
                                                onClick={() => onValidateAgent(true)}
                                                aria-disabled={!isValid}
                                                >
                                                Add
                                            </Button>
                                        </Box>
                                        {(isLicensed && !initialIsLicensedValue) && (
                                            <Box className='backButton'>
                                                <Button
                                                    disableRipple
                                                    component={Link}
                                                    color='primary'
                                                    onClick={() => {
                                                        handlePrevStep()
                                                    }}
                                                    className='back-button'
                                                >
                                                    <SvgIcon
                                                        className='back-arrow'
                                                        component={ArrowBackIosIcon}
                                                    />
                                                    <span>Back</span>
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </MsalAuthenticationTemplate>
        );
    }

export default AddUserPage;
